import styles from './styles.module.css';

import { BottomNavigationBar } from '../../BottomNavigationBar';
import { NavigationBar } from '../../NavigationBar';
import { Copyright } from '../../Copyright';
import { FloatingTutorials } from '../../FloatingTutorials';

export function Navbar(props: any) {
  return (
    <>
      <NavigationBar />
      <div className={styles.bodyContent}>
        <div className={styles.bodyWrapper}>
          <div className={`container ${styles.bodyHeight}`}>
            {props.children}
          </div>
          <div className={styles.bgFooter}>
            <Copyright />
          </div>
        </div>
      </div>
      <BottomNavigationBar />
      <FloatingTutorials />
    </>
  );
}
